/**
 * Route for `top-advertisers-widget`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { TopAdvertisersWidgetPage } from "../features/top-advertisers-widget/TopAdvertisersWidgetPage";

export const topAdvertisersWidgetRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/top-advertisers-widget",
	component: TopAdvertisersWidgetPage,
});

export default topAdvertisersWidgetRoute;
